/* NAMA cart PAGE (ncp-*) — design-handoff cart-page, wired to the live
   Shopify Cart AJAX API. Every mutation calls /cart/change.js then re-renders
   [data-ncp] from /cart?view=namapage (same pattern as the drawer, but a
   fully separate surface — this file must not touch cart-drawer.js).

   Store note: colour is a sibling product, not a variant option, so the
   inline editor edits the line's real options (Size / Length) and offers
   colour across siblings (cross-product-swatches); changing anything is
   remove + add / line change, re-rendered from the server. */
(function () {
  var root = document.querySelector('[data-ncp]');
  if (!root) return;
  var busy = false;

  // ── re-render from the server ───────────────────────────────────
  function refresh() {
    return fetch('/cart?view=namapage', { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (!doc.querySelector('.cart')) return;
        root.innerHTML = doc.body.innerHTML;
      });
  }

  function changeLine(key, qty) {
    if (busy) return;
    busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function () { return refresh(); })
      .then(syncHeaderCount)
      .finally(function () { busy = false; });
  }

  // ── delegated actions (rows are re-rendered wholesale — spec §5) ──
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-act]');
    if (!btn) return;
    var item = btn.closest('[data-item]');
    if (!item) return;
    var act = btn.getAttribute('data-act');
    var key = item.getAttribute('data-key');
    var qtyEl = item.querySelector('[data-qty]');

    if (act === 'inc') { changeLine(key, +qtyEl.textContent + 1); }
    else if (act === 'dec') { if (+qtyEl.textContent > 1) changeLine(key, +qtyEl.textContent - 1); }
    else if (act === 'remove') {
      item.classList.add('gone');
      setTimeout(function () { changeLine(key, 0); }, 240);
    }
    else if (act === 'edit') { openEditor(item); }
    else if (act === 'cancel') { item.classList.remove('editing'); item.querySelector('.ed').innerHTML = ''; }
    // 'apply' is wired inside the editor (needs its closure state)
  });

  // ── caches shared across editors ────────────────────────────────
  var siblingCache = {};  // collection handle -> [{handle,color_name,color_hex,available,...}]
  var productCache = {};  // product handle    -> {options, variants}

  function fetchSiblings(collection) {
    if (siblingCache[collection]) return siblingCache[collection];
    siblingCache[collection] = fetch('/collections/' + collection + '?sections=cross-product-swatches')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var html = d['cross-product-swatches'];
        try { return JSON.parse(new DOMParser().parseFromString(html, 'text/html').body.textContent.trim()); }
        catch (e) { return []; }
      }).catch(function () { return []; });
    return siblingCache[collection];
  }
  function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + handle + '.js').then(function (r) { return r.json(); })
      .then(function (p) {
        return {
          options: (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; }),
          variants: p.variants.map(function (v) { return { id: v.id, options: [v.option1, v.option2, v.option3], available: v.available }; })
        };
      }).catch(function () { return null; });
    return productCache[handle];
  }

  // ── inline editor (Colour across siblings + Size / Length) ───────
  function openEditor(item) {
    var data;
    try { data = JSON.parse(item.querySelector('[data-variants]').textContent); } catch (e) { return; }

    var optAxes = data.options
      .map(function (o, i) { return { name: o.name, pos: i }; })
      .filter(function (o) { return /size|length/i.test(o.name); });

    item.classList.add('editing');
    var ed = item.querySelector('.ed');
    ed.innerHTML = '<p class="eg-l">Loading&hellip;</p>';
    var siblings = data.colour ? fetchSiblings(data.colourCollection) : Promise.resolve([]);
    siblings.then(function (list) { runEditor(item, data, optAxes, list || []); });
  }

  function runEditor(item, data, optAxes, siblings) {
    var esc = function (s) { return String(s).replace(/</g, '&lt;').replace(/"/g, '&quot;'); };
    var colours = siblings.length > 1 ? siblings : [];
    var state = {
      colour: data.colour || null,
      colourHandle: data.handle,
      opts: data.current.slice()
    };
    var matrix = { options: data.options.map(function (o) { return o.name; }), variants: data.variants };

    function handleForColour(name) {
      var s = colours.filter(function (c) { return c.color_name === name; })[0];
      return s ? s.handle : data.handle;
    }
    function variantIn(mx, values) {
      for (var i = 0; i < mx.variants.length; i++) {
        var v = mx.variants[i], ok = true;
        for (var j = 0; j < values.length; j++) { if (values[j] != null && v.options[j] !== values[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function valueAvailable(pos, val) { var p = state.opts.slice(); p[pos] = val; var v = variantIn(matrix, p); return v && v.available; }
    function uniqueValues(pos) {
      var seen = [], out = [];
      matrix.variants.forEach(function (v) { if (seen.indexOf(v.options[pos]) < 0) { seen.push(v.options[pos]); out.push(v.options[pos]); } });
      return out;
    }

    function render() {
      var ed = item.querySelector('.ed');
      var groups = '';
      groups += optAxes.map(function (o) {
        var vals = uniqueValues(o.pos);
        return '<div class="eg"><p class="eg-l">' + esc(o.name) + '</p><div class="opts">' +
          vals.map(function (val) {
            var on = state.opts[o.pos] === val;
            var avail = valueAvailable(o.pos, val);
            return '<button class="opt" type="button" data-opt="' + o.pos + '" data-val="' + esc(val) + '"' +
              (on ? ' aria-pressed="true"' : ' aria-pressed="false"') +
              (avail ? '' : ' disabled aria-label="' + esc(val) + ' — sold out"') + '>' + esc(val) + '</button>';
          }).join('') + '</div></div>';
      }).join('');
      if (colours.length) {
        groups += '<div class="eg"><p class="eg-l">Colour</p><div class="opts">' +
          colours.map(function (c) {
            var on = c.color_name === state.colour;
            var press = on ? ' aria-pressed="true"' : ' aria-pressed="false"';
            var dis = c.available ? '' : ' disabled aria-label="' + esc(c.color_name) + ' — sold out"';
            if (c.color_hex) {
              return '<button class="opt sw" type="button" data-colour="' + esc(c.color_name) + '"' + press + dis +
                ' aria-label="' + esc(c.color_name) + (c.available ? '' : ' — sold out') + '" title="' + esc(c.color_name) + '" style="background:' + esc(c.color_hex) + '"></button>';
            }
            return '<button class="opt" type="button" data-colour="' + esc(c.color_name) + '"' + press + dis + '>' + esc(c.color_name) + '</button>';
          }).join('') + '</div></div>';
      }
      ed.innerHTML = groups +
        '<div class="ed-act"><button class="save" type="button" data-apply>Update</button>' +
        '<button class="cancel" type="button" data-act="cancel">Cancel</button></div>';
      wire();
    }

    function wire() {
      var ed = item.querySelector('.ed');
      ed.querySelectorAll('[data-colour]:not([disabled])').forEach(function (b) {
        b.addEventListener('click', function () {
          var name = b.getAttribute('data-colour');
          state.colour = name;
          state.colourHandle = handleForColour(name);
          // load the chosen colour's matrix so size availability + ids are correct
          fetchProduct(state.colourHandle).then(function (m) {
            if (m) { matrix = m; }
            render();
          });
        });
      });
      ed.querySelectorAll('.opt[data-opt]:not([disabled])').forEach(function (b) {
        b.addEventListener('click', function () {
          state.opts[+b.getAttribute('data-opt')] = b.getAttribute('data-val');
          render();
        });
      });
      ed.querySelector('[data-apply]').addEventListener('click', function () {
        var target = variantIn(matrix, state.opts);
        if (!target || !target.available) return;
        if (String(target.id) === item.getAttribute('data-variant')) {
          item.classList.remove('editing'); ed.innerHTML = ''; return;
        }
        swapVariant(item.getAttribute('data-key'), target.id);
      });
    }

    render();
  }

  // remove the old line, add the chosen variant at the same qty, re-render
  function swapVariant(key, newId) {
    if (busy) return;
    busy = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var line = cart.items.filter(function (i) { return i.key === key; })[0];
      var qty = line ? line.quantity : 1;
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () {
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: newId, quantity: qty })
        });
      });
    }).then(function () { return refresh(); }).then(syncHeaderCount).finally(function () { busy = false; });
  }

  // ── keep the header cart count in sync ──────────────────────────
  function syncHeaderCount() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-bind="itemCount"], .nmd-bag-count, [data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    });
  }
})();
